import { useState } from "react";

import truncate from "lodash/truncate";

import { Box } from "@/components/layout/flexbox";

interface DescriptionProps {
  text: string;
  color?: string;
}

export function Description({ text, color = "#000" }: DescriptionProps) {
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <Box
        color={color}
        css={{
          whiteSpace: "pre-line",
        }}
      >
        {showAll ? text : truncate(text, { length: 160, separator: " " })}
      </Box>
      {showAll ? null : (
        <Box mt="2px">
          <a onClick={() => setShowAll(true)}>
            <b>Read More</b>
          </a>
        </Box>
      )}
    </>
  );
}
